"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { TypographyH2 } from "@/components/ui/typography";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  React.useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div>
      <TypographyH2>Oops! Something went wrong...</TypographyH2>
      <Button
        onClick={() => {
          reset();
        }}
      >
        Try Again
      </Button>
    </div>
  );
}
